import initUserHighlightDataForItem from '../actions/initUserHighlightDataForItem';
import initUserNoteDataForItem from '../actions/initUserNoteDataForItem';
import UserMarkup from '../store/schema/UserMarkup';
import { ClientItem } from 'owa-mail-store';

export default async function getItemUserMarkupData(item: ClientItem): Promise<UserMarkup> {
    let itemUserMarkupData: UserMarkup = {
        userHighlightData: null,
        userNoteData: null,
    };

    if (item) {
        if (!item.userHighlightData) {
            await initUserHighlightDataForItem(item);
        }
        itemUserMarkupData.userHighlightData = item.userHighlightData;

        if (!item.userNoteData) {
            await initUserNoteDataForItem(item);
        }
        itemUserMarkupData.userNoteData = item.userNoteData;
    }

    return itemUserMarkupData;
}
